export enum vNiveauEnum {
  DEFAULT = 'STORK-QAA-Level-1',
  NORMAL = 'STORK-QAA-Level-2',
  SUBSTANZIELL = 'STORK-QAA-Level-3',
  HOCH = 'STORK-QAA-Level-4'
}
